export const PATIENT_SEX_OPTIONS = ["Male", "Female"] as const;

export function amountIncludingTax(amount: number, taxRatePercent: number) {
  return amount + (amount * taxRatePercent) / 100;
}

type BookingLocationState = {
  type: number;
  homeServiceAreaId: string;
  officeLocationId: string;
  slotId: string;
  addressLine1: string;
  addressLine2: string;
  community: string;
  accessDirections: string;
};

export function resetLocationForAppointmentType<
  TState extends BookingLocationState,
>(current: TState, type: number): TState {
  return {
    ...current,
    type,
    homeServiceAreaId: "",
    officeLocationId: "",
    slotId: "",
    addressLine1: "",
    addressLine2: "",
    community: "",
    accessDirections: "",
  };
}

export function updateRequesterEmail<
  TState extends { requesterEmail: string; receiptEmail: string },
>(current: TState, requesterEmail: string): TState {
  const receiptEmail =
    !current.receiptEmail || current.receiptEmail === current.requesterEmail
      ? requesterEmail
      : current.receiptEmail;

  return {
    ...current,
    requesterEmail,
    receiptEmail,
  };
}
